var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavBasket1 = function SvgNavBasket1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "nav_basket1_svg__st3",
    d: "M32.5 18.7c-.2-.3-.6-.4-.9-.4H19.5c-.1 0-.4.1-.4.4s.1.4.4.4h12c.1 0 .3.1.4.1.1.1.1.3.1.4l-1.2 5.1c-.1.4-.4.7-.9.7h-8.2c-.1 0-.4.1-.4.4 0 .1.1.4.4.4H30c.7 0 1.4-.6 1.6-1.3l1.2-5.1c0-.4-.1-.8-.3-1.1zM21.2 30.3c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c.1-.7-.7-1.6-1.6-1.6zm0 2.7c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9c0 .4-.3.9-.9.9zM28.6 30.3c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.8-.7-1.6-1.6-1.6zm0 2.7c-.5 0-.9-.4-.9-.9s.4-.9.9-.9 1 .4 1 .9c0 .4-.5.9-1 .9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "nav_basket1_svg__st3",
    d: "M29.9 27.9H20l-.9-3.6-1.8-7.8c-.1-.4-.5-.7-1-.7H14c-.1 0-.4.1-.4.4 0 .1.1.4.4.4h2.3c.1 0 .3.1.3.2l1.7 7.3v.1l.1.4 1 3.9c.1.1.1.3.4.3H30c.1 0 .4-.1.4-.4s-.3-.5-.5-.5z"
  })));
};
export default SvgNavBasket1;